import { portalDs } from 'src/components/portal-design-system';
import { cn } from 'src/lib/utils';

interface UsageInsightsMetricCardProps {
  label: string;
  value: string;
  className?: string;
}

export function UsageInsightsMetricCard({ label, value, className }: UsageInsightsMetricCardProps) {
  return (
    <div
      className={cn(
        'rounded-xl border border-[#EDEEF2] bg-white p-5 shadow-[0_1px_2px_rgba(13,15,26,0.05)]',
        className,
      )}
    >
      <p className={cn(portalDs.caption, 'uppercase tracking-[0.5px]')}>
        {label}
      </p>
      <p className="mt-2 text-3xl font-bold tracking-[-0.8px] text-[#0D0F1A]">
        {value}
      </p>
    </div>
  );
}

export function UsageInsightsMetricGrid({ children, className }: { children: React.ReactNode; className?: string }) {
  return (
    <div className={cn('grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-5', className)}>
      {children}
    </div>
  );
}
